
const API_BASE_URL = 'https://ilustradoz.online/api';

//const API_BASE_URL ="http://localhost:8080/api"
export {API_BASE_URL};